import React from "react";
import { Box, Container, Divider, Grid, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Logo from "../../logo1_ai copy436_alpha.png";
import { tokens } from "../../theme/theme";
import { CONTACTS } from "../siteConfig";
import { CHRISTMAS, FROST, HALLOWEEN, NIGHT } from "../halloween/season";
import Graveyard from "../halloween/Graveyard";
import { SnowBank } from "../christmas/Edges";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        // The graveyard, or the snowbank, stands in this margin on top of the footer.
        mt: HALLOWEEN ? { xs: 20, md: 24 } : CHRISTMAS ? { xs: 17, md: 19 } : 10,
        pt: 6,
        pb: 4,
        background: HALLOWEEN
          ? "linear-gradient(180deg, " + NIGHT.sky + " 0%, " + NIGHT.deep + " 100%)"
          : CHRISTMAS
          ? "linear-gradient(180deg, " + FROST.sky + " 0%, " + FROST.deep + " 100%)"
          : tokens.ink,
        color: "rgba(255,255,255,0.72)",
      }}
    >
      {HALLOWEEN && <Graveyard />}
      {CHRISTMAS && <SnowBank />}
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Stack direction="row" spacing={1.2} alignItems="center" sx={{ mb: 1.5 }}>
              <Box
                component="img"
                src={Logo}
                alt="LeoCity"
                sx={{ height: 38, filter: "brightness(0) invert(1)", opacity: 0.9 }}
              />
              <Typography variant="h5" sx={{ color: "#fff" }}>
                LeoCity
              </Typography>
            </Stack>
            <Typography variant="body2" sx={{ maxWidth: 380 }}>
              Агенція нерухомості у Львові. Допомагаємо швидко знайти квартиру
              для оренди — без нескінченних дзвінків і застарілих оголошень.
            </Typography>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typography variant="overline" sx={{ color: tokens.sand500 }}>
              Розділи
            </Typography>
            <Stack spacing={1} sx={{ mt: 1.5 }}>
              <Link component={RouterLink} to="/katalog" color="inherit">
                Каталог квартир
              </Link>
              <Link component={RouterLink} to="/krosvord" color="inherit">
                Кросворд дня
              </Link>
              <Link component={RouterLink} to="/kontakty" color="inherit">
                Контакти
              </Link>
              <Link component={RouterLink} to="/admin" color="inherit">
                Вхід для рієлторів
              </Link>
            </Stack>
          </Grid>

          <Grid item xs={6} md={4}>
            <Typography variant="overline" sx={{ color: tokens.sand500 }}>
              Зв'язок
            </Typography>
            <Stack spacing={1} sx={{ mt: 1.5 }}>
              {CONTACTS.phones.map((phone) => (
                <Link key={phone.href} href={"tel:" + phone.href} color="inherit">
                  {phone.label}
                </Link>
              ))}
              <Link
                href={"mailto:" + CONTACTS.email}
                color="inherit"
                // One unbreakable word, wider than its half-width column on a
                // phone — it pushed the whole page 40px wider than the screen.
                sx={{ overflowWrap: "anywhere" }}
              >
                {CONTACTS.email}
              </Link>
              {/* <Typography variant="body2">{CONTACTS.address}</Typography> */}
              <Typography variant="body2">{CONTACTS.hours}</Typography>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.12)" }} />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          spacing={1}
        >
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.55)" }}>
            © {year} LeoCity. Усі права захищено.
          </Typography>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.55)" }}>
            Контактні дані власників не публікуються — зв'язок лише через агенцію.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
